/* istanbul ignore file */
import { boolean as codecBoolean } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const NewAutoTestConfigurationPermissionsParser = 
/* #__PURE__ */ parsers.object([
    ['manage', codecBoolean],
    ['viewTest', codecBoolean, 'view_test'],
    ['viewHidden', codecBoolean, 'view_hidden'],
]);
export class NewAutoTestConfigurationPermissions extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return NewAutoTestConfigurationPermissionsParser.decode(input).map(res => new NewAutoTestConfigurationPermissions(res));
    }
    static unsafeDecode(input) {
        return NewAutoTestConfigurationPermissions.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return NewAutoTestConfigurationPermissionsParser.encode(data);
    }
    static schema() {
        return NewAutoTestConfigurationPermissionsParser.schema();
    }
}
